import { CardCatalog } from '@/components/common/CardCatalog'

import { GalleryEmpty } from '../GalleryEmpty/GalleryEmpty'
import { useGalleryGroups } from '../GalleryGroupsProvider/GalleryGroupsProvider'
import { GalleryPagination } from '../GalleryPagination/GalleryPagination'
import { GallerySubheader } from '../GallerySubheader/GallerySubheader'

import styles from './GalleryViewText.module.scss'

export const GalleryViewText = () => {
  const { groups, isEmpty } = useGalleryGroups()

  return (
    <div className={styles.container}>
      <GallerySubheader icon='font' title='Text View' />
      <div className={styles.content}>{isEmpty ? <GalleryEmpty /> : <CardCatalog groups={groups} hideCount />}</div>
      <GalleryPagination />
    </div>
  )
}
